import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { deleteBlock } from "../../../../services/Register/deleteBlock";
import { useAppContext } from "../../../../context/AppContext";
import { toast } from "react-toastify";

const ModalDeleteBlocks = ({
  visible,
  headerModal,
  handleCloseModal,
  whiteBlocks,
  refetch,
  refresh,
  enterpriseId
}) => {
  const { nomenclatures } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const [loading, setLoading] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedCustomersBlocks, setSelectedCustomersBlocks] = useState(null);
  const [blocksSelecteds, setBlocksSelecteds] = useState(null);
  const totalRecords = whiteBlocks?.length;
  const columns = [{ field: "block", header: nomenclatures[0].value }];
  //  // console.log(whiteBlocks);
  const onSelectAllChange = (event) => {
    setSelectAll(event.checked);
    if (event.checked) {
      // Se o checkbox de seleção estiver marcado, selecionar todos os registros
      setSelectedCustomersBlocks(whiteBlocks);
    } else {
      // Se o checkbox de seleção estiver desmarcado, desmarcar todos os registros
      setSelectedCustomersBlocks([]);
    }
  };

  const onSelectionChange = (event) => {
    const value = event.value; // Obtem o novo valor da seleção
    setSelectedCustomersBlocks(value); // Atualiza o estado com o novo valor


    // Usa o valor atualizado para a verificação em vez de depender do estado
    if (value.length === totalRecords) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };




  const handleDeleteAction = (selectedItems) => {
    setBlocksSelecteds(selectedItems);
  };
  const handleDeleteBlock = (event) => {
    event.preventDefault();
    handleDeleteAction(selectedCustomersBlocks);
  };
  const loadingDelete = (event) => {
    setLoading(true);
  };
  const handleDelete = async () => {
    const notification = toast.loading("Por favor aguarde...");
    setLoading(true);

    const idsBlocks = selectedCustomersBlocks.map(item => item.id);
    const objData = {
      blocks_id: idsBlocks,
      enterprise_id: enterpriseId,
    };

    try {
      const response = await deleteBlock(objData);
      const successMessage = response.success || "Dados excluídos com sucesso!";

      toast.update(notification, {
        render: successMessage,
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });

      setSelectedCustomersBlocks(null);
      await refresh();
      await refetch();
    } catch (error) {
      console.error(`Erro ao excluir blocos:`, error);
      toast.update(notification, {
        render: "Hm..Algo não ocorreu bem.",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <form onSubmit={handleDeleteBlock}>
        <Dialog
          id="modal_cad"
          className="rounded-4"
          visible={visible}
          header={`Exclusão de ${nomenclature[0].value}`}
          footer={(props) => {
            if (whiteBlocks.length === 0) {
              return null; // Retorna null para um footer vazio se whiteBlocks estiver vazio
            } else {
              return headerModal({ ...props, handleDelete, loadingDelete });
            }
          }}
          onHide={handleCloseModal}
          style={{ width: "70vw" }}
        >
          <DataTable
            stripedRows
            showGridlines
            sortMode="multiple"
            selectionMode="multiple"
            value={whiteBlocks}
            totalRecords={whiteBlocks}
            // loading={loading}
            selectAll={selectAll}
            selection={selectedCustomersBlocks}
            onSelectionChange={(e) => {
              const selectedItems = e.value || [];
              onSelectionChange(e);
              handleDeleteAction(selectedItems);
            }}
            onSelectAllChange={onSelectAllChange}
            emptyMessage="Nenhuma Informação foi encontrada."
            tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
          >
            <Column
              field="id"
              headerStyle={{ width: "3rem" }}
              selectionMode="multiple"
            // filterMatchMode={FilterMatchMode.CONTAINS}
            />
            {columns.map((col) => (
              <Column
                sortable
                key={col.field}
                field={col.field}
                header={col.header}
                body={col.body}
                style={col.style}
              />
            ))}
          </DataTable>
        </Dialog>
      </form>
    </>
  );
};

export default ModalDeleteBlocks;
